import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Styled.
import * as S from './styled';

const VARIANT_MAP = {
  regular: 'neutral',
  neutral: 'neutral',
  info: 'brand',
  brand: 'brand',
  success: 'success',
  warning: 'warning',
  error: 'danger',
  danger: 'danger',
};

const COLORS = Object.keys(VARIANT_MAP);

const renderIcon = (icon) => {
  if (!icon) return null;
  if (typeof icon === 'string') {
    const resolved = byPrefixAndName.fas[icon];
    if (!resolved) return null;
    return <FontAwesomeIcon icon={resolved} />;
  }
  return <FontAwesomeIcon icon={icon} />;
};

const Badge = ({
  id = undefined,
  className = '',
  color = 'regular',
  filled = false,
  icon = undefined,
  uppercase = false,
  children,
}) => (
  <S.Badge
    id={id}
    className={className}
    appearance="filled"
    variant={VARIANT_MAP[color] || 'neutral'}
    $filled={filled}
    $uppercase={uppercase}
  >
    {renderIcon(icon)}
    {children}
  </S.Badge>
);

Badge.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  filled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  uppercase: PropTypes.bool,
  children: PropTypes.node,
};

export default Badge;
